import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
import _imports_0 from '../../assets/map/bgyunl.png';
import _imports_1 from '../../assets/map/bgyunr.png';
import _imports_2 from '../../assets/map/return.png';
const _hoisted_1 = ["src"];
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "mapnotouch"
};
const _hoisted_4 = {
  id: "map",
  class: "map_content",
  ref: "maps"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  id: "bdmap",
  class: "bdmap",
  ref: "bdmap"
};
const _hoisted_7 = {
  class: "dialog-footer"
};
const _hoisted_8 = {
  class: "yunbox",
  ref: "yunbox"
};
const _hoisted_9 = {
  key: 2,
  class: "footerContainer"
};
const _hoisted_10 = {
  class: "view"
};
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = {
  key: 3,
  class: "footerContainer"
};
const _hoisted_13 = {
  class: "view"
};
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = {
  class: "m-switchArea-style1"
};
const _hoisted_16 = {
  class: "swiper-container swiperbox visibleitem",
  ref: "swipercontainer"
};
const _hoisted_17 = {
  class: "swiper-wrapper"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  class: "thImage"
};
const _hoisted_20 = {
  id: "bdmap",
  class: "bdmap",
  ref: "bdmap"
};
const _hoisted_21 = {
  key: 4,
  class: "views-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_maptype = _resolveComponent("maptype");
  const _component_mappopup = _resolveComponent("mappopup");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_maplist = _resolveComponent("maplist");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mapcontainer", [`width${$data.bodywidth}`, {
      'ipad': $data.isIpad
    }]]),
    onClick: _cache[8] || (_cache[8] = $event => $options.addClickNum())
  }, [_createElementVNode("img", {
    class: "mapbg",
    src: $options.handleHttp($data.mapconfigData.mapbg),
    alt: ""
  }, null, 8, _hoisted_1), _createElementVNode("div", {
    class: _normalizeClass(["logo", [{
      'mobile': $data.isApp
    }, `model${$data.modeltype}`, `fid${$data.fid}`, `id${$data.formUserId}`]]),
    style: _normalizeStyle($data.jsonOption.logo)
  }, [_createElementVNode("img", {
    class: "logoimg",
    src: $options.handleHttp($data.mapconfigdatas.logo),
    alt: ""
  }, null, 8, _hoisted_2)], 6), _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [[_vShow, $data.noTouch]]), _createElementVNode("div", _hoisted_4, null, 512), $data.typeshow ? (_openBlock(), _createBlock(_component_maptype, {
    key: 0,
    typedata: $data.typeList,
    jsonOption: $data.jsonOption,
    currentType: $data.currentType,
    typemodel: $data.typemodel,
    ispc: $data.isApp,
    onTypeclick: $options.typeselect
  }, null, 8, ["typedata", "jsonOption", "currentType", "typemodel", "ispc", "onTypeclick"])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["pickey", [{
      'mobile': $data.isApp
    }, `fid${$data.fid}`]]),
    style: _normalizeStyle($data.jsonOption.pickey)
  }, [_createElementVNode("img", {
    src: $options.handleHttp($data.mapconfigdatas.pickey),
    alt: ""
  }, null, 8, _hoisted_5)], 6), [[_vShow, $data.mapconfigdatas.pickey]]), _createVNode(_component_mappopup, {
    detail: $data.detail,
    popshowflag: $data.popshowflag,
    modeltype: $data.modeltype,
    bodywidth: $data.bodywidth,
    pointStruct: $data.pointStruct,
    onCloseHandle: $options.closeHandle
  }, null, 8, ["detail", "popshowflag", "modeltype", "bodywidth", "pointStruct", "onCloseHandle"]), _withDirectives(_createElementVNode("div", {
    class: "shade",
    onClick: _cache[0] || (_cache[0] = $event => $data.popshowflag = false)
  }, null, 512), [[_vShow, $data.popshowflag && $data.modeltype !== 4]]), _createVNode(_component_el_dialog, {
    "custom-class": "bdmapcontainer",
    modelValue: $data.bdDialog,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.bdDialog = $event),
    title: "位置信息"
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_7, [_createVNode(_component_el_button, {
      onClick: _cache[1] || (_cache[1] = $event => $data.bdDialog = false)
    }, {
      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("取消", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[2] || (_cache[2] = $event => $data.bdDialog = false)
    }, {
      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("确定", -1)]))]),
      _: 1
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, null, 512), _createElementVNode("h4", null, _toDisplayString($data.bdmap.address), 1)]),
    _: 1
  }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_8, [...(_cache[11] || (_cache[11] = [_createElementVNode("img", {
    class: "yunl",
    src: _imports_0,
    alt: ""
  }, null, -1), _createElementVNode("img", {
    class: "yunr",
    src: _imports_1,
    alt: ""
  }, null, -1)]))], 512), _createElementVNode("div", {
    class: "gobackright",
    ref: "gobackright",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.gobackright && $options.gobackright(...args))
  }, [...(_cache[12] || (_cache[12] = [_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }, null, -1), _createElementVNode("p", null, "返回首页", -1)]))], 512), $data.dataList !== '' ? (_openBlock(), _createBlock(_component_maplist, {
    key: 1,
    isApp: $data.isApp,
    dataList: $data.dataList,
    iconSource: $data.iconSource,
    mapdataform: $data.mapdataform,
    typeList: $data.typeList,
    onListmarkerclick: $options.listmarkerclick
  }, null, 8, ["isApp", "dataList", "iconSource", "mapdataform", "typeList", "onListmarkerclick"])) : _createCommentVNode("", true), $data.mapconfigdatas.footerinfo && $data.mapconfigdatas.footerinfo.viewflag && $data.mapconfigdatas.visits === undefined ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, "平台访问量：" + _toDisplayString($data.viewCount), 1), _createElementVNode("div", {
    class: "copyright",
    innerHTML: $data.mapconfigdatas.footerinfo.copyright
  }, null, 8, _hoisted_11)])) : _createCommentVNode("", true), $data.mapconfigdatas.visits !== undefined ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, "平台访问量：" + _toDisplayString($data.mapconfigdatas.visits), 1), $data.mapconfigdatas.footerinfo && $data.mapconfigdatas.footerinfo.copyright ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "copyright",
    innerHTML: $data.mapconfigdatas.footerinfo.copyright
  }, null, 8, _hoisted_14)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
    class: "leftcon",
    onClick: _cache[5] || (_cache[5] = $event => $options.xatoLink('631193597'))
  }), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.xaAreaList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["swiper-slide", {
        'on': $data.xatoIndex === index
      }]),
      key: index,
      onClick: $event => $options.xatoLink(item.formUserId)
    }, _toDisplayString(item.name), 11, _hoisted_18);
  }), 128))])], 512)], 512), [[_vShow, $data.fid === '5569']]), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["xakongming", `formuserid${$data.formUserId}`])
  }, [...(_cache[13] || (_cache[13] = [_createElementVNode("div", {
    class: "item"
  }, null, -1), _createElementVNode("div", {
    class: "item"
  }, null, -1), _createElementVNode("div", {
    class: "item"
  }, null, -1), _createElementVNode("div", {
    class: "item"
  }, null, -1)]))], 2), [[_vShow, $data.fid === '5569']]), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["goback", `fid${$data.fid}`]),
    onClick: _cache[6] || (_cache[6] = (...args) => $options.gobackright && $options.gobackright(...args))
  }, null, 2), [[_vShow, $data.fid === '5569']]), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["leftbottomgoback", `fid${$data.fid}`]),
    onDblclick: _cache[7] || (_cache[7] = (...args) => $options.gobackright && $options.gobackright(...args))
  }, null, 34), [[_vShow, $data.fid !== '5569']]), _withDirectives(_createElementVNode("div", _hoisted_19, [...(_cache[14] || (_cache[14] = [_createElementVNode("img", {
    src: "https://p.ananas.chaoxing.com/star3/origin/cdd20f7980f7bd0ae7c47991c56ee5fa.png",
    alt: ""
  }, null, -1)]))], 512), [[_vShow, $data.tjthimg]]), _createElementVNode("div", _hoisted_20, null, 512), $data.mapconfigdatas.djl && $data.mapconfigdatas.fwl ? (_openBlock(), _createElementBlock("ul", _hoisted_21, [_createElementVNode("li", null, "访问量：" + _toDisplayString($data.mapconfigdatas.fwl), 1), _createElementVNode("li", null, "点击量：" + _toDisplayString($data.mapconfigdatas.djl), 1)])) : _createCommentVNode("", true)], 2);
}